import { createStore } from "vuex";

const store = createStore({
  state() {
    return {
      user: {
        token: "",
        id: "",
      },
      profile:'',
      validity:'',
      expiredIn: '',
    };
  },
  mutations: {
    setUser(state, payload) {
      state.user = { ...payload };
    },
    setProfile(state, payload) {
        state.profile = payload;
      },
      setUserValidity(state, payload) {
        state.validity = payload;
      },
       setExpiredIn(state, payload) {
        state.expiredIn = payload;
      },
  },
  actions: {
    updateUser({ commit }, payload) {
      commit("setUser", payload);
    },
    updateProfile({ commit }, payload) {
        commit("setProfile", payload);
      },
      updateUserValidity({ commit }, payload) {
        commit("setUserValidity", payload);
      },
      updateExpiredIn({ commit }, payload) {
        commit("setExpiredIn", payload);
      },
  },
});

export default store;
